<template>
  <div id="app">
    <div id="loginBox" v-if="!isLoggedIn">
      <LoginComponent
        @onLoggedIn="onLoggedIn"
      >
      </LoginComponent>
    </div>
    <div id="loggedInContainer" v-if="isLoggedIn">
      <nav id="topNavbar" class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
        <a class="navbar-brand col-md-3 col-lg-2 mr-0 px-3" href="#">
          <img src="./assets/logoLight.png" height="50" alt="">
        </a>
        <!--
        <b-button 
          class="navbar-toggler position-absolute d-md-none collapsed" 
          type="button" 
          v-b-toggle.sidebarMenu
          aria-label="Toggle navigation"
          >
          <span class="navbar-toggler-icon"></span>
        </b-button>
        -->
        <!--
        <input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search">
        -->
        <ul class="navbar-nav px-3">
          <li class="nav-item text-nowrap">
            <a @click="logout" class="nav-link" href="#">Esci</a>
          </li>
        </ul>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <nav class="col-md-2 d-none d-md-block bg-light sidebar">
            <div class="sidebar-sticky">
              <ul class="nav flex-column sidebarUl">
                <li class="nav-item">
                  <router-link class="nav-link" to="/listini">
                    <span class="fa fa-list"></span>
                    Listini
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/listiniTariffeInternazionali">
                    <span class="fa fa-money-check"></span>
                    Tariffe Listini
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/utenze">
                    <span class="fa fa-phone-alt"></span>
                    Utenze
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/numerazioni">
                    <span class="fa fa-list-ol"></span>
                    Numerazioni
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/fornitori">
                    <span class="fa fa-address-book"></span>
                    Fornitori
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/cdr_upload">
                    <span class="fa fa-file-upload"></span>
                    Carica CDR
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/cdrDettaglio">
                    <span class="fa fa-project-diagram"></span>
                    Dettagli CDR
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>
          <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-md-4">
            <!--
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 class="h2">Dashboard</h1>
              <div class="btn-toolbar mb-2 mb-md-0">
                <div class="btn-group mr-2">
                  <button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
                </div>
                <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
                  <span data-feather="calendar"></span>
                  This week
                </button>
              </div>
            </div>
            -->
            <router-view />
          </main>
        </div>
      </div>
    </div>

    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    -->
  </div>
</template>

<script>
import LoginComponent from '@/components/Login'
import Vue from 'vue';
import itMessages from "devextreme/localization/messages/it.json";
import { locale, loadMessages } from "devextreme/localization";

export default {
  components: {
    LoginComponent
  },
  created() {
    loadMessages(itMessages);
    locale('it');
    Vue.$svc.setBvModalReference(this.$bvModal);
  },
  data() {
    return {
      isLoggedIn: Vue.$svc.isLoggedIn
    };
  },
  methods: {
    onLoggedIn() {
      this.isLoggedIn = Vue.$svc.isLoggedIn;
    },
    logout() {
      sessionStorage.clear();
      this.isLoggedIn = false;
    }
  }
}

</script>

<style lang="scss">
#topNavbar {  
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #212529 !important;
  text-align: left !important;
}

.sidebarUl {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    a {
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
}

#app {
  /*
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  */
  color: #2c3e50;
}

#loginBox {
  height: 100vh;
  -ms-flex-align: center;
  align-items: center;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

/*
 * Sidebar
 */

.sidebar {
  position: fixed !important;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100; /* Behind the navbar */
  padding: 84px 0 0; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

@media (max-width: 767.98px) {
  .sidebar {
    top: 5rem;
  }
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}

/*
 * Navbar
 */

.navbar-brand {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: 1rem;
  background-color: rgba(0, 0, 0, .25);
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
}

.navbar .navbar-toggler {
  top: .25rem;
  right: 1rem;
}

.navbar .form-control {
  padding: .75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, .1);
  border-color: rgba(255, 255, 255, .1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
}

</style>
